/* eslint-disable no-unused-vars */
import DataTable from "react-data-table-component";
import { toast } from "react-toastify";
import { useExport } from "../../../../hooks/useExport";
import styled from "styled-components";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Schema } from "../../../../validators/schema/schema";




const ResponsiveResumeTable = ({ data }) => {
  const {
    handleSubmit,
    formState: { errors },
    control,
    register,
  } = useForm({
    resolver: yupResolver(Schema().resumeCohortFormSchema),
    mode: "onBlur",
  });


  const { deleteIcon } = useExport();

  const columns = [
    {
      name: "Full Name",
      selector: (row) => row.fullName,
      sortable: true,
      wrap: true,
    },
    {
      name: "Email",
      selector: (row) => <a href={`mailto:${row.email}`}>{row.email}</a>,
      sortable: true,
      wrap: true,
    },
    {
      name: "Gender",
      selector: (row) => row.gender,
      sortable: true,
    },
    {
      name: "Qualification",
      selector: (row) => row.educationalQualification,
      sortable: true,
      wrap: true,
    },
    {
      name: "Emp. Status",
      selector: (row) => row.employmentStatus,
      sortable: true,
      wrap: true,
    },
    {
      name: "Seeking Opp.",
      selector: (row) => row.activeSeekingOpportunities,
      sortable: true,
      wrap: true,
    },
    {
      name: "Cohort",
      selector: (row) => row.cohort,
      sortable: true,
    },
    {
      name: "Resume",
      selector: (row) => row.resume,
      cell: (row) =>
        row.resume ? (
          <a href={row.resume} target="_blank" rel="noopener noreferrer">
            View Resume
          </a>
        ) : (
          "No Resume"
        ),
    },
    {
      name: "Delete",
      cell: (row) => (
        <div style={{ display: "flex", gap: "12px", cursor: "pointer" }}>
          <img
            src={deleteIcon}
            alt="delete-attendee"
            onClick={() => {
              toast.info("Coming soon...");
              console.log(row.id);
            }}
          />
        </div>
      ),
    },
  ];
  return (
    <>

      <TableWrapper>
        <DataTable
          columns={columns}
          data={data}
          pagination
          highlightOnHover
          striped
          customStyles={customStyles}
          title="Eraconneckt Resume Clinic Applicant Data"
          noDataComponent="No applicants found for the selected month"
        />
      </TableWrapper>
    </>
  );
};

export default ResponsiveResumeTable;

const TableWrapper = styled.div`
  margin-top: 40px;
  overflow-x: auto;
`;

const customStyles = {
  headRow: {
    style: {
      backgroundColor: "#4f4f4f",
      color: "#ffffff",
      fontWeight: "bold",
      fontSize: "1rem",
    },
  },
};
